import { render } from "./TopicoPagina.vue?vue&type=template&id=5b78e956&scoped=true"
import script from "./TopicoPagina.vue?vue&type=script&lang=js"
export * from "./TopicoPagina.vue?vue&type=script&lang=js"

import "./TopicoPagina.vue?vue&type=style&index=0&id=5b78e956&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b78e956"]])

export default __exports__